// extracted by mini-css-extract-plugin
module.exports = {"profileSection":"navigationProfileSection_profileSection__2MtmA","name":"navigationProfileSection_name__2cgAm"};